import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import Input from '../../Input';
import { Container } from '../LegacyPhoneNumberWidget/PhoneNumberWidget.styles';
import { PhoneNumberButton } from '../DesktopPhoneNumberWidget/DesktopPhoneNumberWidget.styles';
import { Flexbox } from '../../Flexbox';

import greenCheckmark from '@/images/green-checkmark-circle.svg';

interface ViralLoopsWidgetInputProps {
  success?: boolean;
  error?: boolean;
}

export const StyledParagraph = styled('p')`
  ${({ theme }) => `
    color: ${theme.color.emailInputBorderError};
    margin-left: ${theme.spacing.s};
    font-size: ${theme.fontSize.s};
  `}
`;

export const MobileContainer = styled(Container)`
  color: ${({ theme }) => theme.color.emailInputBorderError};
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  max-width: ${pxToRem(590)};
  height: ${pxToRem(300)};
  padding: 0px;
  margin: ${({ theme }) => theme.spacing.s};
  flex-direction: row;
`;

export const EmailInputWrapper = styled(Flexbox)`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MobileEmailButton = styled(PhoneNumberButton)`
  margin: 0;
  max-width: ${pxToRem(200)};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  font-size: ${pxToRem(18)};
  padding: ${({ theme }) => theme.spacing.m};
  margin-top: 0;
  height: ${pxToRem(64)};
  min-height: ${pxToRem(64)};
  margin-left: ${({ theme }) => theme.spacing.s};

  ${mediaQueries[0]} {
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    border-radius: ${({ theme }) => theme.borderRadius.button_desktop};
    width: ${pxToRem(100)};
    min-width: fit-content;
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
  }

  ${mediaQueries.min} {
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    border-radius: ${({ theme }) => theme.borderRadius.button_desktop};
    width: ${pxToRem(100)};
    min-width: fit-content;
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
  }

  ${mediaQueries.tablet} {
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    border-radius: ${({ theme }) => theme.borderRadius.button_desktop};
    width: ${pxToRem(100)};
    min-width: fit-content;
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
  }

  ${mediaQueries.max} {
    font-size: ${({ theme }) => theme.fontSize.sm};

    width: ${pxToRem(137)};
    min-width: fit-content;
    height: ${pxToRem(56)};
    min-height: ${pxToRem(56)};
  }
`;

export const EmailWidgetInput = styled(Input, {
  shouldForwardProp: (prop) =>
    !['success', 'ctaText', 'error'].includes(prop as string)
})<ViralLoopsWidgetInputProps>`
  opacity: 1;
  flex: 1 1 auto;
  border: ${({ theme, error }) =>
    `${pxToRem(1)} solid ${
      error ? theme.color.emailInputBorderError : theme.color.emailInputBorder
    }`};
  background-color: ${({ theme, success }) =>
    `${success ? theme.color.emailInputBackground : theme.color.white}`};
  background-image: url(${({ success }) =>
    `${success ? greenCheckmark.src : ''}`});
  background-repeat: no-repeat;
  background-position: 3% 50%;
  height: ${pxToRem(64)};
  font-size: ${({ theme, success }) =>
    `${success ? theme.fontSize.sm : theme.fontSize.m}`};
  ${mediaQueries[0]} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(142)};
    min-width: ${pxToRem(142)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    padding: ${({ theme }) => theme.spacing.s};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }
  ${mediaQueries.min} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(142)};
    min-width: ${pxToRem(142)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    padding: ${({ theme }) => theme.spacing.s};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }
  ${mediaQueries.desktop} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(190)};
    min-width: ${pxToRem(190)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize.s};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
  }

  ${mediaQueries.max} {
    height: ${pxToRem(56)};
    min-height: ${pxToRem(56)};
    width: ${pxToRem(211)};
    font-size: ${({ theme }) => theme.fontSize.sm};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #e4e4e4;
    border: 1px solid #bfbfbf;
    opacity: 0.5;
  }
`;
